import i18next from "i18next";
import axios, { simpleErrorHandling } from "config/network";

const getZohoSettings = async () => {
  try {
    const response = await axios.get(
        `/api/v1/GeneralSettings/zoho-settings?culture=${i18next.language}`);
    return response.data;
  } catch (err) {
    if (err.message) {
      throw err;
    } else {
      throw new Error("Failed to get Zoho settings");
    }
  }
};

export const zohoService = {
  getZohoSettings,

};
